import { EntityTypeId } from "./EntityTypeId.enum"

export const riverEntEntityTypeIdList = [
  EntityTypeId.Sea,
  EntityTypeId.Lake,
  EntityTypeId.Swamp,
  EntityTypeId.Marsh,
  // EntityTypeId.River, // rivers are NOT exits, rivers use exists
  // EntityTypeId.Shoal, // shoals are NOT exits
]

export default function isEntityTypeIdRiverExit(etype_id: EntityTypeId) {
  return riverEntEntityTypeIdList.includes(etype_id)
}